import { useRef, useEffect } from 'react';

/**
 * Custom hook to sync the selected loan term and credit tier with the payments info in Redux
 * @param {number} selectedLoanTerm - The currently selected loan term
 * @param {string} selectedCreditTier - The currently selected credit tier
 * @param {Object} paymentsInfo - The payments info object from Redux
 * @param {Function} updatePaymentsInfo - Function to update payments info in Redux
 * @returns {void}
 */
function useSyncLoanTermWithPaymentsInfo(selectedLoanTerm, selectedCreditTier, paymentsInfo, updatePaymentsInfo) {
  const prevSelectedLoanTermRef = useRef(selectedLoanTerm);
  const prevSelectedCreditTierRef = useRef(selectedCreditTier);
  useEffect(() => {
    // Update if selectedLoanTerm has changed and is different from Wallet payment term
    const loanTermChanged = selectedLoanTerm !== prevSelectedLoanTermRef.current && selectedLoanTerm !== paymentsInfo.loanTerm;

    // Update if credit tier changed and selectedLoanTerm is different from Wallet payment term
    const creditTierChanged = selectedCreditTier !== prevSelectedCreditTierRef.current && selectedLoanTerm !== paymentsInfo.loanTerm;
    if (loanTermChanged || creditTierChanged) {
      updatePaymentsInfo({
        ...paymentsInfo,
        loanTerm: selectedLoanTerm
      });
    }
    prevSelectedLoanTermRef.current = selectedLoanTerm;
    prevSelectedCreditTierRef.current = selectedCreditTier;

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedLoanTerm, selectedCreditTier]);
}
export { useSyncLoanTermWithPaymentsInfo as default };
